import React, { useState } from 'react';
import Select from 'react-select';
import styles from './ModalSelector.module.css';
import SolidChevron from '../icons/SolidChevron';
import { components } from 'react-select';

const ModalPickerSelector = ({
  title = '',
  options = [],
  selectedValue = null,
  onChange,
  formatOptionLabel,
  isSearchable = false,
  placeholder = '',
  containerClassName = '',
  containerStyle = {},
}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <SolidChevron color='var(--color-primary)' size={18} />
      </components.DropdownIndicator>
    );
  };

  const handleChange = (option) => {
    onChange?.(option);
    closeModal();
  };

  const openModal = () => {
    setModalOpened(true);
    setShowOverlay(true);

    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setModalOpened(false);
    setTimeout(() => setShowOverlay(false), 300);

    document.body.style.overflow = '';
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'var(--color-dark-gray) !important',
      borderColor: 'rgba(255, 255, 255, 0.1)',
      borderWidth: '1px',
      boxShadow: 'none !important',
      minHeight: '44px',
      borderRadius: '12px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',

      ':hover': {
        backgroundColor: 'var(--color-dark-gray) !important',
        borderColor: '#3b82f6',
      },

      background: 'var(--color-dark-gray) !important',
    }),

    singleValue: (provided) => ({
      ...provided,
      color: '#ffffff',
      fontWeight: '500',
    }),

    placeholder: (provided) => ({
      ...provided,
      color: 'rgba(255, 255, 255, 0.5)',
      fontWeight: '400',
    }),

    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--color-dark-gray)',
      borderRadius: '12px',
      marginTop: 8,
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      overflow: 'hidden',
    }),

    menuList: (provided) => ({
      ...provided,
      maxHeight: 260,
      overflowY: 'auto',
      padding: '8px',
      '::-webkit-scrollbar': {
        width: '6px',
      },
      '::-webkit-scrollbar-track': {
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '8px',
      },
      '::-webkit-scrollbar-thumb': {
        background: 'rgba(59, 130, 246, 0.5)',
        borderRadius: '8px',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: 'rgba(59, 130, 246, 0.7)',
      },
    }),

    option: (provided, state) => {
      const hasSelected = state.getValue && state.getValue().length > 0;
      const isSelected = hasSelected && state.isSelected;

      return {
        ...provided,
        WebkitTapHighlightColor: 'transparent',
        ':active': {
          backgroundColor: 'var(--color-grey)',
        },
        backgroundColor: isSelected
          ? 'rgba(59,130,246,0.25)'
          : hasSelected
          ? state.isFocused
            ? 'rgba(255,255,255,0.08)'
            : 'transparent'
          : 'transparent',
        color: isSelected ? '#fff' : 'rgba(255,255,255,0.9)',
        fontWeight: isSelected ? 600 : 400,
        ...(!hasSelected && state.isFocused ? { backgroundColor: 'transparent' } : {}),
        padding: '12px 14px',
        cursor: 'pointer',
        borderRadius: '8px',
        marginBottom: '4px',
        transition: 'all .3s cubic-bezier(0.16,1,0.3,1)',
      };
    },

    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'transform .3s ease',
      transformOrigin: 'center',
      marginRight: '10px',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    }),

    indicatorSeparator: () => ({ display: 'none' }),
  };

  const displayLabel = selectedValue?.label || selectedValue?.value || placeholder;

  return (
    <>
      <div className={containerClassName} style={containerStyle} onClick={openModal}>
        <span>{displayLabel}</span>
        <span>
          {/* <ChevronIcon size={18} fillColor='var(--color-primary)' rotation={90} /> */}
          <SolidChevron size={18} color='var(--color-primary)' />
        </span>
      </div>

      {showOverlay && (
        <div
          className={`${styles.overlay} ${modalOpened ? styles.overlayVisible : ''}`}
          onClick={closeModal}
        />
      )}

      <div className={`${styles.modalPicker} ${modalOpened ? styles.modalPickerOpened : ''}`}>
        <div className={`${styles.modalTitle} mb-2 semi-bold`}>{title}</div>

        <Select
          value={selectedValue}
          onChange={handleChange}
          options={options}
          isSearchable={isSearchable}
          formatOptionLabel={formatOptionLabel}
          styles={customStyles}
          placeholder={placeholder}
          components={{
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
        />

        <div className='close-page' onClick={closeModal}>
          <div className='mdiv'>
            <div className='md'></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalPickerSelector;
